import script from "./CalendarioSemanal.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioSemanal.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioSemanal.vue?vue&type=style&index=0&id=0d193828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d193828"]])

export default __exports__